import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

export function toPromise<T>(ob: Observable<T>) {
    return ob.pipe(first()).toPromise();
}

export function compareObjectArrays(arr1: any[], arr2: any[]): boolean {
    const objectsEqual = (o1: any, o2: any): boolean => {
        if (o1 === o2) return true;
        if (o1 === null || o2 === null) return o1 === o2;

        if (typeof o1 !== 'object' || typeof o2 !== 'object') return false;

        // Array check
        if (Array.isArray(o1) !== Array.isArray(o2)) return false;
        if (Array.isArray(o1)) {
            if (o1.length !== o2.length) return false;
            return o1.every((v, i) => objectsEqual(v, o2[i]));
        }

        // Object check
        const keys1 = Object.keys(o1);
        const keys2 = Object.keys(o2);
        if (keys1.length !== keys2.length) return false;

        return keys1.every(k => objectsEqual(o1[k], o2[k]));
    };

    return (
        arr1.length === arr2.length &&
        arr1.every((o, idx) => objectsEqual(o, arr2[idx]))
    );
}

export const gerAlerts = (stops) => {
    const alerts = {
        missingStockJobs: [],
        missingConfirmationJobs: [],
        poorAddressJobs: [],
        etaOutOfTimeWindowJobs: []
    };
    stops.forEach(stop=>{
        const jobAlerts = stop.getAlerts();

        if(jobAlerts.poorAddress){
            alerts.poorAddressJobs.push(stop);
        }
        if(jobAlerts.missingStock){
            alerts.missingStockJobs.push(stop);
        }
        if (jobAlerts.etaOutOfTimeWindow) {
            alerts.etaOutOfTimeWindowJobs.push(stop);
        }
        if (jobAlerts.missingConfirmation) {
            alerts.missingConfirmationJobs.push(stop);
        }
    });
    return alerts;
};